"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const mark_1 = require("./mark");
class Strike extends mark_1.Mark {
    constructor() {
        super('strike');
    }
}
exports.Strike = Strike;
//# sourceMappingURL=strike.js.map